import { authentication, logOut, clearReference, cerrarSesion, loginActive } from "./app-database"; 
import { goTo } from "./tools";

cIdle.$inject = ["IdleProvider", "KeepaliveProvider"];

export function cIdle(IdleProvider, KeepaliveProvider) {
	IdleProvider.idle(1200); // in seconds 1200
	IdleProvider.timeout(5); // in seconds
	KeepaliveProvider.interval(20); // in seconds
}

rIdle.$inject = ["$rootScope", "Idle", "Keepalive"];
export function rIdle($rootScope, Idle) {

	$rootScope.$on("IdleStart", function() {
		console.log("IdleStart");
	});
	
	$rootScope.$on("IdleEnd", function() {
		console.log("IdleEnd");
	});

	$rootScope.$on("Keepalive", function() {
		rutinaKeepalive();
	});

	$rootScope.$on("IdleTimeout", function() {
		let stateView = angular.element(document.querySelector("ui-view")).data("$uiView");
		if (stateView && stateView.state.self.name != "app") {
			console.log("IdleTimeout");
			cerrarSesion();
			authentication.signOut().then(()=> {
				console.log("Se limpian conecciones de firebase");
				clearReference();
			});
		}
	});
	
	authentication.onAuthStateChanged(function (user) {
		if (user && user.isAnonymous == false) {
			console.log("IdleStart");
			Idle.watch();
			rutinaKeepaliveIn();
		} else {
			console.log("IdleStop");
			Idle.unwatch();
			rutinaKeepaliveOut();
		}
	});
}

function rutinaKeepalive() {
	console.log("rutinaKeepalive");
	window.localStorage.setItem("ngIdleSesionDate", new Date().getTime());
}

function funcionCierraSesion() {
	console.log('me imprimo');
	loginActive();
}

function rutinaKeepaliveIn() {
	console.log("rutinaKeepaliveIn");
	let ngIdleSesionDate = window.localStorage.getItem("ngIdleSesionDate");
	if(ngIdleSesionDate != null) {
		let timestamp = new Date().getTime();
		let sesionExpire = parseInt(ngIdleSesionDate) + 1200000; // 20 minutos
		if(timestamp > sesionExpire) {
			if(!(/movil/g.test(window.location.hash))) {
				logOut();
				authentication.signOut().then(()=> {
					alert("Tu sesión ha expirado");
					
					try {
						let redux = angular.element(document.querySelector('ui-view')).scope().$parent.state.redux;
						redux.dispatch({ "type": "INITIALIZE_STATE_FALSE" });
					} catch(error) {
						console.log("cerrar sesion por tiempo expirado", error);
					}
					
					goTo("login");
				});
			}
		}
	} else {
		rutinaKeepalive();
	}
}

function rutinaKeepaliveOut() {
	console.log("rutinaKeepaliveOut");
	window.localStorage.removeItem("ngIdleSesionDate");
}


// WEBPACK FOOTER //
// ./src/app-idle.js